import { WSButton, WSButtonProps } from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";

type Props = {
  to: string;
} & WSButtonProps<"Link">;

export const ButtonLink: React.FC<Props> = props => {
  const history = useHistory();
  const { to, children, ...buttonProps } = props;

  return (
    <WSButton.Link
      mx="XS"
      {...buttonProps}
      onClick={() => {
        history.push(to);
      }}
      type="button"
    >
      {children}
    </WSButton.Link>
  );
};
